import { render } from "./AppMain.vue?vue&type=template&id=628f23b3&scoped=true"
const script = {}

import "./AppMain.vue?vue&type=style&index=0&id=628f23b3&lang=scss&scoped=true"

import exportComponent from "D:\\project\\official-website-manage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-628f23b3"]])

export default __exports__